<template>
    <div>
        <el-container style="width: 100%; margin: auto; padding: 50px">
            <el-header class="el-card" style="height: 100px; padding: 30px">
                <div @click="$router.back()">
                    <img src="./img/icon.png" style="height: 40px" />
                </div>
            </el-header>
            <el-main style="padding: 0; padding-top: 20px" v-loading="loading">
                <el-container>
                    <el-aside width="500px" style="padding-top: 20px">
                        <el-form label-position="left" label-width="120px">
                            <el-tabs
                                type="border-card"
                                :before-leave="tabs_change"
                                v-model="selectedTab"
                                style="height: 100%; position: relative"
                            >
                                <el-tab-pane label="基本特征" name="1">
                                    <el-form-item label="卧室数量">
                                        <el-radio
                                            v-model="search_model.room_count"
                                            label="1"
                                            >一室</el-radio
                                        >
                                        <el-radio
                                            v-model="search_model.room_count"
                                            label="2"
                                            >二室</el-radio
                                        >
                                        <el-radio
                                            v-model="search_model.room_count"
                                            label="3"
                                            >三室</el-radio
                                        >
                                        <el-radio
                                            v-model="search_model.room_count"
                                            label="4"
                                            >四室</el-radio
                                        >
                                    </el-form-item>
                                    <el-form-item label="卫生间数量">
                                        <el-radio
                                            v-model="search_model.toilet_count"
                                            label="1"
                                            >一卫</el-radio
                                        >
                                        <el-radio
                                            v-model="search_model.toilet_count"
                                            label="2"
                                            >二卫</el-radio
                                        >
                                    </el-form-item>
                                    <el-form-item label="其他房间">
                                        <el-checkbox
                                            v-model="search_model.is_living"
                                            >客厅</el-checkbox
                                        >
                                        <el-checkbox
                                            v-model="search_model.is_dinner"
                                            >餐厅</el-checkbox
                                        >
                                        <el-checkbox
                                            v-model="search_model.is_kitchen"
                                            >厨房</el-checkbox
                                        >
                                    </el-form-item>
                                    <el-form-item label="总面积区间(M^2)">
                                        <el-slider
                                            v-model="search_model.area_range"
                                            range
                                            show-stops
                                            :max="90"
                                            :min="20"
                                            :step="10"
                                            :marks="area_marks"
                                        >
                                        </el-slider>
                                    </el-form-item>
                                    <el-form-item label="面宽区间(M)">
                                        <el-slider
                                            v-model="search_model.face_range"
                                            range
                                            show-stops
                                            :max="13"
                                            :min="3"
                                            :marks="marks"
                                        >
                                        </el-slider>
                                    </el-form-item>
                                    <el-form-item label="进深区间(M)">
                                        <el-slider
                                            v-model="search_model.depth_range"
                                            range
                                            show-stops
                                            :max="15"
                                            :min="3"
                                            :marks="marks"
                                        >
                                        </el-slider>
                                    </el-form-item>
                                    <el-form-item label="朝向">
                                        <el-radio
                                            v-model="search_model.direction"
                                            label="0"
                                            >南向</el-radio
                                        >
                                        <el-radio
                                            v-model="search_model.direction"
                                            label="1"
                                            >北向</el-radio
                                        >
                                        <el-radio
                                            v-model="search_model.direction"
                                            label="2"
                                            >东西向</el-radio
                                        >
                                    </el-form-item>
                                </el-tab-pane>
                                <el-tab-pane label="功能倾向" name="3">
                                    <el-form-item label="套型">
                                        <el-checkbox
                                            v-model="search_model.面宽进深比"
                                            >面宽进深比</el-checkbox
                                        >
                                        <el-checkbox
                                            v-model="
                                                search_model.单位面积房间数
                                            "
                                            >单位面积房间数</el-checkbox
                                        >
                                        <el-checkbox
                                            v-model="search_model.户型通透性"
                                            >户型通透性</el-checkbox
                                        >
                                    </el-form-item>
                                    <el-form-item label="房间">
                                        <el-checkbox
                                            v-model="search_model.房间面积指标"
                                            >房间面积</el-checkbox
                                        >
                                        <el-checkbox
                                            v-model="search_model.房间面宽指标"
                                            >房间面宽</el-checkbox
                                        >
                                        <el-checkbox
                                            v-model="search_model.房间进深指标"
                                            >房间进深</el-checkbox
                                        >
                                    </el-form-item>
                                    <el-form-item label="分区">
                                        <el-checkbox v-model="search_model.分区"
                                            >动静分区</el-checkbox
                                        >
                                    </el-form-item>
                                    <el-form-item label="采光与朝向">
                                        <el-checkbox
                                            v-model="search_model.房间朝向主"
                                            >房间朝向</el-checkbox
                                        >
                                        <el-checkbox
                                            v-model="
                                                search_model.房间采光深度主
                                            "
                                            >房间采光深度</el-checkbox
                                        >
                                        <el-checkbox
                                            v-model="
                                                search_model.房间采光宽度主
                                            "
                                            >房间采光宽度</el-checkbox
                                        >
                                        <el-checkbox v-model="search_model.明厨"
                                            >明厨</el-checkbox
                                        >
                                        <el-checkbox v-model="search_model.明卫"
                                            >明卫</el-checkbox
                                        >
                                    </el-form-item>
                                    <el-form-item label="流线">
                                        <el-checkbox
                                            v-model="search_model.过道面积占比"
                                            >流线面积占比</el-checkbox
                                        >
                                        <el-checkbox
                                            v-model="search_model.过道复杂度"
                                            >流线复杂度</el-checkbox
                                        >
                                    </el-form-item>
                                </el-tab-pane>
                                <el-tab-pane label="边界轮廓" name="4">
                                    <el-row>
                                        <el-col
                                            v-for="i in rooms"
                                            :key="i.type"
                                            :span="4"
                                        >
                                            <el-checkbox
                                                v-model="i.checked"
                                                :type="
                                                    i.checked
                                                        ? 'primary'
                                                        : 'plain'
                                                "
                                                size="mini"
                                                style="margin-bottom: 10px"
                                                >{{ i.name }}</el-checkbox
                                            >
                                        </el-col>
                                    </el-row>

                                    <div
                                        @mousedown="cancelActive"
                                        class="designer_container"
                                    >
                                        <template v-for="(i, e) in rooms">
                                            <simple-rect
                                                ref="rects"
                                                v-if="i.checked"
                                                :key="e"
                                                :index="e"
                                                :data="i"
                                                :mark-visable="true"
                                                :length-rate="30"
                                                @rectChange="rectChange"
                                            >
                                                <div
                                                    style="
                                                        width: 100%;
                                                        height: 100%;
                                                        background: black;
                                                    "
                                                ></div>
                                            </simple-rect>
                                        </template>
                                    </div>
                                </el-tab-pane>
                                <el-tab-pane name="xx">
                                    <el-button
                                        slot="label"
                                        @click="search"
                                        type="primary"
                                        style="border-radius: 0; border: none"
                                    >
                                        搜索</el-button
                                    >
                                </el-tab-pane>
                            </el-tabs>
                        </el-form>
                    </el-aside>
                    <el-main
                        v-if="projects.length == 0"
                        style="padding: 0 0 0 20px"
                    >
                        <el-empty description="暂无符合条件的案例"></el-empty>
                    </el-main>
                    <el-main
                        v-if="projects.length != 0"
                        style="padding: 0 0 0 20px"
                    >
                        <div class="content_wrap">
                            <div
                                class="content_item"
                                v-for="item in projects"
                                :key="item.name"
                            >
                                <h3 style="margin: 10px 0">{{ item.name }}</h3>
                                <div
                                    class="img_wrap"
                                    @click="openProject(item)"
                                >
                                    <CaseView
                                        style="
                                            width: 150px;
                                            height: 120px;
                                            margin: auto;
                                        "
                                        :data="item"
                                        :height="120"
                                        :width="150"
                                    ></CaseView>
                                </div>
                                <!-- <div class="AuthorAndDownload">
                                    <span>{{ item.time }}</span>
                                    <i @click="delProj(item)" class="el-icon-delete"></i>
                                    <i @click="download(item)" class="el-icon-download"></i>
                                </div> -->
                            </div>
                        </div>
                    </el-main>
                </el-container>
            </el-main>
            <el-footer>
                <el-pagination
                    @current-change="pageChange"
                    :current-page="pager.currentPage"
                    :page-sizes="[2, 18, 36, 72]"
                    :page-size="pager.size"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="pager.total"
                    style="text-align: right"
                >
                </el-pagination>
            </el-footer>
        </el-container>
    </div>
</template>
<script>
import axios from "axios";
import SimpleRect from "./components/simple-rect.vue";
import CaseView from "./components/CaseView.vue";
import { baseUrl } from "./config/baseUrl.js";
import { commit_rooms, dic_types } from "./api/options";
import { getUser } from "./api/user";
import { getInstance } from "./api/orm";
export default {
    name: "sample-page",
    components: { CaseView, SimpleRect },
    data: () => {
        return {
            search_model: {
                room_count: "1",
                toilet_count: "1",
                is_dinner: false,
                is_kitchen: false,
                is_living: false,
                area_range: [20, 90],
                face_range: [3, 13],
                depth_range: [3, 15],
                is_light_kitchen: false,
                is_light_toilet: false,
                direction: "0",
            },
            area_marks: {},
            marks: {},
            radio: "1",
            selectedTab: "1",
            rects: [],
            user: null,
            projects: [],
            search_text: "",
            sort_type: "",
            pager: {
                currentPage: 1,
                total: 1,
                size: 18,
            },
            loading: false,
            rooms: [],
        };
    },
    async created() {
        for (let i = 0; i < 100; i += 10) {
            this.area_marks[i] = i.toString();
        }
        for (let i = 0; i < 100; i++) {
            this.marks[i] = i.toString();
        }
        let user = await getUser();
        if (!user) {
            this.$router.push("/LoginPage");
            return;
        }
        for (let i of [
            "boundary",
            "entrance",
            "white_south",
            "white_north",
            "white_third",
            "black1",
            "black2",
            "black3",
            "black4",
        ]) {
            this.rooms.push({
                type: i,
                name: dic_types[i],
                checked: false,
                left: 0,
                top: 0,
                width: 100,
                height: 100,
            });
        }
        this.user = user;
        await this.search();
    },
    methods: {
        tabs_change(b1, b2) {
            if (b1 == "xx") return false;
            return true;
        },
        rectChange(index, left, top, width, height) {
            this.rooms[index].width = width;
            this.rooms[index].height = height;
            this.rooms[index].top = top;
            this.rooms[index].left = left;
        },
        cancelActive() {
            for (let i of this.$refs.rects) {
                i.setActive(false);
            }
        },
        addRect() {
            this.rects.push({
                width: 100,
                height: 100,
                left: 0,
                top: 0,
                active: false,
            });
        },
        delRect() {
            let arr = [];
            for (let i in this.$refs.rects) {
                if (this.$refs.rects[i].active) arr.push(i);
            }
            for (let i = arr.length - 1; i >= 0; i -= 1) {
                this.rects.splice(i, 1);
            }
        },
        goUser() {
            this.$router.push("/UserManager");
        },
        async delProj(item) {
            await axios.post(`${baseUrl}/design/case_base/delete`, {
                id: item.id,
            });
            await this.search();
        },
        newProject() {
            this.$router.push("/WorkSpace/0");
        },
        openProject(row) {
            // if (!row.duration) {
            //     this.$message.error("此任务还没有计算完成，不能查看！");
            //     return;
            // }
            this.$router.push("/WorkSpace/case_" + row.id);
        },
        async pageChange(index) {
            this.pager.currentPage = index;
            await this.search();
        },
        generate_post_rooms() {
            let res = JSON.parse(JSON.stringify(this.rooms));
            res.filter((i) => {
                i.left *= 30;
                i.top *= 30;
                i.width *= 30;
                i.height *= 30;
            });
            let boundary = res.filter((i) => {
                return i.type == "boundary";
            });
            if (boundary) boundary = boundary[0];
            else {
                return [];
            }
            let offsetX = boundary["left"];
            let offsetY = boundary["top"] + boundary["height"];
            res.filter((e) => {
                if (e.left) {
                    e.left = e.left - offsetX;
                    e.top = offsetY - (e.top + e.height);
                }
            });
            return res;
        },
        async search() {
            this.loading = true;
            let orm = getInstance({
                app_name: "design",
                model_name: "case_base",
            });
            let cond = [
                {
                    page: this.pager.currentPage,
                    limit: this.pager.size,
                    order: "id",
                },
            ];
            cond.push({ room_count: this.search_model.room_count });
            cond.push({ toilet_count: this.search_model.toilet_count });
            if (this.search_model.is_dinner) cond.push({ is_dinner: 1 });
            if (this.search_model.is_living) cond.push({ is_living: 1 });
            if (this.search_model.is_kitchen) cond.push({ is_kitchen: 1 });
            cond.push({ direction: this.search_model.direction });
            if (this.search_model.is_light_kitchen)
                cond.push({ is_light_kitchen: 1 });
            if (this.search_model.is_light_toilet)
                cond.push({ is_light_toilet: 1 });
            cond.push({
                condition: `area between ${this.search_model.area_range[0]} and ${this.search_model.area_range[1]}`,
            });
            cond.push({
                condition: `width between ${this.search_model.face_range[0]} and ${this.search_model.face_range[1]}`,
            });
            cond.push({
                condition: `depth between ${this.search_model.depth_range[0]} and ${this.search_model.depth_range[1]}`,
            });
            let checkboxes = [];
            for (let i in this.search_model) {
                if (this.search_model[i] == true) checkboxes.push(i);
            }
            cond.push({ checkboxes: checkboxes });
            cond.push({ data_frame: this.generate_post_rooms() });
            let data = await orm.search({
                post: cond,
            });
            this.projects = data.data;
            this.pager.currentPage = data.pageindex;
            this.pager.total = data.datacount;
            this.pager.size = data.pagesize;
            this.loading = false;
        },
    },
};
</script>
<style scoped>
.designer_container {
    position: relative;
    width: 100%;
    height: 500px;
    background-size: 20px 20px, 20px 20px;
    background-image: linear-gradient(rgba(0, 0, 0, 0.1) 1px, transparent 0),
        linear-gradient(90deg, rgba(0, 0, 0, 0.1) 1px, transparent 0);
}
body {
    box-sizing: border-box;
}

.action_wrap {
    display: flex;
    align-items: center;
    justify-content: right;
    padding-right: 20px;
}

.action_wrap .s_inp {
    width: 150px;
    margin-right: 20px;
}

.content_wrap {
    width: 100%;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
}

.content_wrap .content_item {
    width: 150px;
    margin: 17px;
    background: #fff;
    box-shadow: 1px 2px 20px 2px rgba(0, 0, 0, 0.123);
    padding: 10px;
}

.content_wrap .content_item .img_wrap {
    flex-direction: row;
    align-items: center;
    justify-content: center;
    height: 120px;
    width: 100%;
    text-align: center;
}

.content_wrap .content_item .img_wrap img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.AuthorAndDownload {
    margin-top: 6px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.AuthorAndDownload img {
    width: 20px;
}

.mask {
    background: #487489;
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 99999;
    display: flex;
    align-items: center;
}

.fade_out {
    opacity: 0;
    transition-duration: 1s;
    transition-property: opacity;
}

.el-slider {
    width: 90%;
}
</style>